import DefaultLogger from "./DefaultLogger.js";
var Log = new DefaultLogger();
export default Log;
//# sourceMappingURL=Log.js.map